module.exports = __webpack_public_path__ + "static/media/coaching-for-a-specific-issue@3x.3ee787fa.png";